/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const abrLookup = /* GraphQL */ `
  query AbrLookup($abn: String) {
    abrLookup(abn: $abn) {
      abn
      abnStatus
      abnStatusEffectiveFrom
      acn
      addressDate
      addressPostcode
      addressState
      businessName
      entityName
      entityTypeCode
      entityTypeName
      gst
      message
      type
    }
  }
`;
export const abrLookupByName = /* GraphQL */ `
  query AbrLookupByName($name: String) {
    abrLookupByName(name: $name) {
      items {
        abn
        abnStatus
        isCurrent
        name
        nameType
        postcode
        state
      }
    }
  }
`;
export const autocompleteResultsByType = /* GraphQL */ `
  query AutocompleteResultsByType(
    $type: AutocompleteType!
    $searchName: String!
    $sortDirection: ModelSortDirection
    $filter: ModelEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    autocompleteResultsByType(
      type: $type
      searchName: $searchName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        value
        label
        info
        type
        searchName
        metadata {
          subCategory
          payoutMethod
          billerCode
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAutoComplete = /* GraphQL */ `
  query GetAutoComplete($id: ID!) {
    getAutoComplete(id: $id) {
      entity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      contact {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
    }
  }
`;
export const listBillers = /* GraphQL */ `
  query ListBillers($searchName: String!) {
    listBillers(searchName: $searchName) {
      items {
        billerCode
        shortName
        longName
        type
      }
      nextToken
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      entityId
      xeroTenantId
      entityType
      firstName
      lastName
      email
      mobile
      phone
      taxNumber
      companyNumber
      name
      legalName
      searchName
      status
      website
      createdAt
      updatedAt
      contactType
      bank {
        id
        accountName
        bankName
        accountNumber
        routingNumber
        holderType
        accountType
        country
      }
      bpay {
        billerCode
        referenceNumber
      }
      invalidFields
      bulkUploadFileKey
      owner
      createdBy
      beneficiaryBankId
      beneficiaryBpayId
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      postal {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      payoutErrors
    }
  }
`;
export const contactsByEntity = /* GraphQL */ `
  query ContactsByEntity(
    $entityId: ID!
    $searchName: String
    $sortDirection: ModelSortDirection
    $from: Int
  ) {
    contactsByEntity(
      entityId: $entityId
      searchName: $searchName
      sortDirection: $sortDirection
      from: $from
    ) {
      items {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
      total
    }
  }
`;
export const getDocumentAnalysis = /* GraphQL */ `
  query GetDocumentAnalysis($id: ID!) {
    getDocumentAnalysis(id: $id) {
      id
      entityId
      firmId
      fileKey
      documents {
        identityId
        key
        level
        type
        name
      }
      status
      expenseStatus
      queryStatus
      matchedBiller {
        billerCode
        billerCategory
        shortName
        longName
        type
        industryCode
        industryCodeDescription
        createdAt
        updatedAt
      }
      matchedContactId
      matchedContact {
        id
        entityId
        xeroTenantId
        entityType
        firstName
        lastName
        email
        mobile
        phone
        taxNumber
        companyNumber
        name
        legalName
        searchName
        status
        website
        createdAt
        updatedAt
        contactType
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
        invalidFields
        bulkUploadFileKey
        owner
        createdBy
        beneficiaryBankId
        beneficiaryBpayId
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        postal {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        payoutErrors
      }
      matchedEntityId
      matchedEntity {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      newContact {
        firstName
        lastName
        email
        mobile
        phone
        name
        taxNumber
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
      }
      task {
        reference
        dueAt
        issuedAt
        lodgementAt
        paymentAt
        gstInclusive
        notes
        amount
        gstAmount
        taxAmount
        lineItems {
          description
          quantity
          unitPrice
          price
          productCode
          taxType
        }
        numberOfPayments
        paymentFrequency
        shippingAmount
        settlementStatus
        partnerId
        managerId
        documentType
        subCategory
        category
        period
        year
      }
      bpay {
        billerCode
        referenceNumber
      }
      bank {
        accountNumber
        routingNumber
      }
      category
      source
      isCorrect
      fromEmail
      textContent
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const documentAnalysisByEntityStatus = /* GraphQL */ `
  query DocumentAnalysisByEntityStatus(
    $entityId: ID!
    $status: DocumentAnalysisStatus
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    documentAnalysisByEntityStatus(
      entityId: $entityId
      status: $status
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        entityId
        firmId
        fileKey
        documents {
          identityId
          key
          level
          type
          name
        }
        status
        expenseStatus
        queryStatus
        matchedBiller {
          billerCode
          billerCategory
          shortName
          longName
          type
          industryCode
          industryCodeDescription
          createdAt
          updatedAt
        }
        matchedContactId
        matchedContact {
          id
          entityId
          xeroTenantId
          entityType
          firstName
          lastName
          email
          mobile
          phone
          taxNumber
          companyNumber
          name
          legalName
          searchName
          status
          website
          createdAt
          updatedAt
          contactType
          bank {
            id
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            country
          }
          bpay {
            billerCode
            referenceNumber
          }
          invalidFields
          bulkUploadFileKey
          owner
          createdBy
          beneficiaryBankId
          beneficiaryBpayId
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          postal {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          payoutErrors
        }
        matchedEntityId
        matchedEntity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        newContact {
          firstName
          lastName
          email
          mobile
          phone
          name
          taxNumber
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
        }
        task {
          reference
          dueAt
          issuedAt
          lodgementAt
          paymentAt
          gstInclusive
          notes
          amount
          gstAmount
          taxAmount
          lineItems {
            description
            quantity
            unitPrice
            price
            productCode
            taxType
          }
          numberOfPayments
          paymentFrequency
          shippingAmount
          settlementStatus
          partnerId
          managerId
          documentType
          subCategory
          category
          period
          year
        }
        bpay {
          billerCode
          referenceNumber
        }
        bank {
          accountNumber
          routingNumber
        }
        category
        source
        isCorrect
        fromEmail
        textContent
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const documentAnalysisByFirmStatus = /* GraphQL */ `
  query DocumentAnalysisByFirmStatus(
    $firmId: ID!
    $status: DocumentAnalysisStatus
    $createdBy: String
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    documentAnalysisByFirmStatus(
      firmId: $firmId
      status: $status
      createdBy: $createdBy
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        entityId
        firmId
        fileKey
        documents {
          identityId
          key
          level
          type
          name
        }
        status
        expenseStatus
        queryStatus
        matchedBiller {
          billerCode
          billerCategory
          shortName
          longName
          type
          industryCode
          industryCodeDescription
          createdAt
          updatedAt
        }
        matchedContactId
        matchedContact {
          id
          entityId
          xeroTenantId
          entityType
          firstName
          lastName
          email
          mobile
          phone
          taxNumber
          companyNumber
          name
          legalName
          searchName
          status
          website
          createdAt
          updatedAt
          contactType
          bank {
            id
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            country
          }
          bpay {
            billerCode
            referenceNumber
          }
          invalidFields
          bulkUploadFileKey
          owner
          createdBy
          beneficiaryBankId
          beneficiaryBpayId
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          postal {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          payoutErrors
        }
        matchedEntityId
        matchedEntity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        newContact {
          firstName
          lastName
          email
          mobile
          phone
          name
          taxNumber
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
        }
        task {
          reference
          dueAt
          issuedAt
          lodgementAt
          paymentAt
          gstInclusive
          notes
          amount
          gstAmount
          taxAmount
          lineItems {
            description
            quantity
            unitPrice
            price
            productCode
            taxType
          }
          numberOfPayments
          paymentFrequency
          shippingAmount
          settlementStatus
          partnerId
          managerId
          documentType
          subCategory
          category
          period
          year
        }
        bpay {
          billerCode
          referenceNumber
        }
        bank {
          accountNumber
          routingNumber
        }
        category
        source
        isCorrect
        fromEmail
        textContent
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEntity = /* GraphQL */ `
  query GetEntity($id: ID!) {
    getEntity(id: $id) {
      id
      type
      taxNumber
      companyNumber
      billerCode
      name
      legalName
      businessNames
      searchName
      address {
        addressId
        contactName
        contactNumber
        fullAddress
        address1
        address2
        city
        country
        countryCode
        state
        stateCode
        postalCode
        invalid
      }
      logo {
        alt
        identityId
        key
        level
        type
      }
      brandColour
      website
      entityUsers {
        items {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        nextToken
      }
      gstRegistered
      gstReportingPeriod
      providerEntityId
      providerCompanyId
      providerBillUserCompanyId
      providerBankAccountId
      providerDigitalWalletId
      providerBpayCrn
      contact {
        firstName
        lastName
        email
        phone
        role
      }
      paymentMethods {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      paymentMethodId
      paymentUserId
      disbursementMethodId
      receivingAccounts {
        items {
          id
          paymentMethodType
          type
          fullName
          number
          expMonth
          expYear
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          status
          accountDirection
          expiresAt
          createdAt
          updatedAt
          consentId
          consentStatus
          card
          googlepay
          applepay
        }
        nextToken
      }
      ubosCreated
      numUbosCreated
      subCategory
      clientsStatus
      ocrEmail
      termsInvoiceAccepted
      termsOcrAccepted
      owner
      referredBy
      connectedAccount
      accountStatus
      customerId
      xeroSyncStatus
      xeroLastContactSyncAt
      xeroContactSyncStatus
      xeroInvoiceSyncStatus
      xeroLastInvoiceSyncAt
      xeroTenantId
      absorbFees
      subscriptionTier
      invitationStatus
      clientsOnboardingStatus
      createdBy
      createdByEntityId
      isFirm
      createdAt
      updatedAt
    }
  }
`;
export const searchEntities = /* GraphQL */ `
  query SearchEntities(
    $searchName: String
    $clientsStatus: EntityClientsStatus
    $limit: Int
    $from: Int
    $sortBy: String
    $sortDirection: ModelSortDirection
  ) {
    searchEntities(
      searchName: $searchName
      clientsStatus: $clientsStatus
      limit: $limit
      from: $from
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      items {
        id
        type
        taxNumber
        companyNumber
        billerCode
        name
        legalName
        businessNames
        searchName
        address {
          addressId
          contactName
          contactNumber
          fullAddress
          address1
          address2
          city
          country
          countryCode
          state
          stateCode
          postalCode
          invalid
        }
        logo {
          alt
          identityId
          key
          level
          type
        }
        brandColour
        website
        entityUsers {
          items {
            id
            entityId
            userId
            firmId
            email
            invitedEmail
            ocrEmail
            referredBy
            invitedEntityId
            firmEntityId
            providerContactId
            ownerCode
            clientGroupCode
            clientCode
            firstName
            lastName
            role
            jobTags
            paymentsEnabled
            termsInvoiceAccepted
            termsOcrAccepted
            termsFirmPayTaxAccepted
            termsFirmPayTaxDetails {
              document {
                identityId
                key
                level
                type
                name
              }
              acceptedAt
              email
              ip
              fullName
              firmId
            }
            entitySearchName
            entity {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            firm {
              id
              type
              taxNumber
              companyNumber
              billerCode
              name
              legalName
              businessNames
              searchName
              address {
                addressId
                contactName
                contactNumber
                fullAddress
                address1
                address2
                city
                country
                countryCode
                state
                stateCode
                postalCode
                invalid
              }
              logo {
                alt
                identityId
                key
                level
                type
              }
              brandColour
              website
              entityUsers {
                items {
                  id
                  entityId
                  userId
                  firmId
                  email
                  invitedEmail
                  ocrEmail
                  referredBy
                  invitedEntityId
                  firmEntityId
                  providerContactId
                  ownerCode
                  clientGroupCode
                  clientCode
                  firstName
                  lastName
                  role
                  jobTags
                  paymentsEnabled
                  termsInvoiceAccepted
                  termsOcrAccepted
                  termsFirmPayTaxAccepted
                  entitySearchName
                  searchName
                  taxNumber
                  taskSendSMS
                  companyNumber
                  createdBy
                  createdAt
                  updatedAt
                  status
                  partnerId
                  managerId
                  archivedAt
                }
                nextToken
              }
              gstRegistered
              gstReportingPeriod
              providerEntityId
              providerCompanyId
              providerBillUserCompanyId
              providerBankAccountId
              providerDigitalWalletId
              providerBpayCrn
              contact {
                firstName
                lastName
                email
                phone
                role
              }
              paymentMethods {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              paymentMethodId
              paymentUserId
              disbursementMethodId
              receivingAccounts {
                items {
                  id
                  paymentMethodType
                  type
                  fullName
                  number
                  expMonth
                  expYear
                  accountName
                  bankName
                  accountNumber
                  routingNumber
                  holderType
                  accountType
                  status
                  accountDirection
                  expiresAt
                  createdAt
                  updatedAt
                  consentId
                  consentStatus
                  card
                  googlepay
                  applepay
                }
                nextToken
              }
              ubosCreated
              numUbosCreated
              subCategory
              clientsStatus
              ocrEmail
              termsInvoiceAccepted
              termsOcrAccepted
              owner
              referredBy
              connectedAccount
              accountStatus
              customerId
              xeroSyncStatus
              xeroLastContactSyncAt
              xeroContactSyncStatus
              xeroInvoiceSyncStatus
              xeroLastInvoiceSyncAt
              xeroTenantId
              absorbFees
              subscriptionTier
              invitationStatus
              clientsOnboardingStatus
              createdBy
              createdByEntityId
              isFirm
              createdAt
              updatedAt
            }
            searchName
            taxNumber
            taskSendSMS
            companyNumber
            createdBy
            createdAt
            updatedAt
            status
            partnerId
            managerId
            archivedAt
            taxPaymentReferences {
              itr {
                referenceNumber
                updatedAt
              }
              other {
                referenceNumber
                updatedAt
              }
            }
          }
          nextToken
        }
        gstRegistered
        gstReportingPeriod
        providerEntityId
        providerCompanyId
        providerBillUserCompanyId
        providerBankAccountId
        providerDigitalWalletId
        providerBpayCrn
        contact {
          firstName
          lastName
          email
          phone
          role
        }
        paymentMethods {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        paymentMethodId
        paymentUserId
        disbursementMethodId
        receivingAccounts {
          items {
            id
            paymentMethodType
            type
            fullName
            number
            expMonth
            expYear
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            status
            accountDirection
            expiresAt
            createdAt
            updatedAt
            consentId
            consentStatus
            card
            googlepay
            applepay
          }
          nextToken
        }
        ubosCreated
        numUbosCreated
        subCategory
        clientsStatus
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        owner
        referredBy
        connectedAccount
        accountStatus
        customerId
        xeroSyncStatus
        xeroLastContactSyncAt
        xeroContactSyncStatus
        xeroInvoiceSyncStatus
        xeroLastInvoiceSyncAt
        xeroTenantId
        absorbFees
        subscriptionTier
        invitationStatus
        clientsOnboardingStatus
        createdBy
        createdByEntityId
        isFirm
        createdAt
        updatedAt
      }
      total
    }
  }
`;
export const entityUsersByUser = /* GraphQL */ `
  query EntityUsersByUser(
    $searchName: String
    $role: EntityUserRole
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
  ) {
    entityUsersByUser(
      searchName: $searchName
      role: $role
      sortDirection: $sortDirection
      from: $from
      limit: $limit
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      total
    }
  }
`;
export const entityUsersByEntityId = /* GraphQL */ `
  query EntityUsersByEntityId(
    $entityId: ID!
    $searchName: String
    $roles: [EntityUserRole]
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
    $nextToken: String
  ) {
    entityUsersByEntityId(
      entityId: $entityId
      searchName: $searchName
      roles: $roles
      sortDirection: $sortDirection
      from: $from
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      total
    }
  }
`;
export const entityUsersByFirmId = /* GraphQL */ `
  query EntityUsersByFirmId(
    $firmId: ID!
    $searchName: String
    $clientGroupCode: String
    $roles: [EntityUserRole]
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
    $nextToken: String
    $includeArchived: Boolean
    $archivedOnly: Boolean
  ) {
    entityUsersByFirmId(
      firmId: $firmId
      searchName: $searchName
      clientGroupCode: $clientGroupCode
      roles: $roles
      sortDirection: $sortDirection
      from: $from
      limit: $limit
      nextToken: $nextToken
      includeArchived: $includeArchived
      archivedOnly: $archivedOnly
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      total
    }
  }
`;
export const notificationsByUser = /* GraphQL */ `
  query NotificationsByUser(
    $sortDirection: ModelSortDirection
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    notificationsByUser(
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        message
        status
        createdAt
        updatedAt
        type
        owner
      }
      nextToken
    }
  }
`;
export const getOption = /* GraphQL */ `
  query GetOption($id: ID!) {
    getOption(id: $id) {
      name
      label
      value
      group
      createdAt
      updatedAt
      id
    }
  }
`;
export const listOptions = /* GraphQL */ `
  query ListOptions(
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        name
        label
        value
        group
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const optionsByName = /* GraphQL */ `
  query OptionsByName(
    $name: String!
    $label: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionsByName(
      name: $name
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        name
        label
        value
        group
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const optionsByGroup = /* GraphQL */ `
  query OptionsByGroup(
    $group: String!
    $label: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    optionsByGroup(
      group: $group
      label: $label
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        name
        label
        value
        group
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const getPaymentGuest = /* GraphQL */ `
  query GetPaymentGuest($id: ID!) {
    getPaymentGuest(id: $id) {
      id
      entityId
      taskId
      paymentIntentId
      amount
      installment
      installments
      feeAmount
      paymentType
      taxAmount
      currency
      feeId
      status
      payerUserStatus
      isUnlimitedRecurring
      scheduledAt
      paidAt
      createdAt
      updatedAt
      owner
    }
  }
`;
export const getService = /* GraphQL */ `
  query GetService($id: ID!) {
    getService(id: $id) {
      id
      entityId
      title
      description
      amount
      feeType
      taxType
      searchName
      status
      createdAt
      updatedAt
    }
  }
`;
export const servicesByEntity = /* GraphQL */ `
  query ServicesByEntity(
    $entityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    servicesByEntity(
      entityId: $entityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        title
        description
        amount
        feeType
        taxType
        searchName
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTask = /* GraphQL */ `
  query GetTask($id: ID!, $entityId: ID!) {
    getTask(id: $id, entityId: $entityId) {
      entityId
      taskNumber
      invoiceStatus
      agreementUuid
      documentType
      subCategory
      id
      linkedTaskId
      managerId
      partnerId
      bindingId
      futureLinkedTask {
        fromId
        fromType
        toId
        toType
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      documentAnalysisId
      activity {
        items {
          id
          compositeId
          userId
          entityId
          type
          message
          metadata {
            name
            email
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      amount
      taxAmount
      annotations
      entityIdFrom
      fromId
      fromType
      toId
      toType
      firmId
      entityIdTo
      contactIdFrom
      contactIdTo
      contactId
      entityByIdContactId
      firmByIdContactId
      firmById
      searchName
      status
      quoteStatus
      signatureStatus
      paymentStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      emailMessage
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      maximumInstallments
      reference
      bpayReferenceNumber
      settlementStatus
      signers {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        ocrEmail
        referredBy
        invitedEntityId
        firmEntityId
        providerContactId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        termsFirmPayTaxDetails {
          document {
            identityId
            key
            level
            type
            name
          }
          acceptedAt
          email
          ip
          fullName
          firmId
        }
        entitySearchName
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        firm {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          entityUsers {
            items {
              id
              entityId
              userId
              firmId
              email
              invitedEmail
              ocrEmail
              referredBy
              invitedEntityId
              firmEntityId
              providerContactId
              ownerCode
              clientGroupCode
              clientCode
              firstName
              lastName
              role
              jobTags
              paymentsEnabled
              termsInvoiceAccepted
              termsOcrAccepted
              termsFirmPayTaxAccepted
              termsFirmPayTaxDetails {
                document {
                  identityId
                  key
                  level
                  type
                  name
                }
                acceptedAt
                email
                ip
                fullName
                firmId
              }
              entitySearchName
              entity {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              firm {
                id
                type
                taxNumber
                companyNumber
                billerCode
                name
                legalName
                businessNames
                searchName
                address {
                  addressId
                  contactName
                  contactNumber
                  fullAddress
                  address1
                  address2
                  city
                  country
                  countryCode
                  state
                  stateCode
                  postalCode
                  invalid
                }
                logo {
                  alt
                  identityId
                  key
                  level
                  type
                }
                brandColour
                website
                entityUsers {
                  nextToken
                }
                gstRegistered
                gstReportingPeriod
                providerEntityId
                providerCompanyId
                providerBillUserCompanyId
                providerBankAccountId
                providerDigitalWalletId
                providerBpayCrn
                contact {
                  firstName
                  lastName
                  email
                  phone
                  role
                }
                paymentMethods {
                  nextToken
                }
                paymentMethodId
                paymentUserId
                disbursementMethodId
                receivingAccounts {
                  nextToken
                }
                ubosCreated
                numUbosCreated
                subCategory
                clientsStatus
                ocrEmail
                termsInvoiceAccepted
                termsOcrAccepted
                owner
                referredBy
                connectedAccount
                accountStatus
                customerId
                xeroSyncStatus
                xeroLastContactSyncAt
                xeroContactSyncStatus
                xeroInvoiceSyncStatus
                xeroLastInvoiceSyncAt
                xeroTenantId
                absorbFees
                subscriptionTier
                invitationStatus
                clientsOnboardingStatus
                createdBy
                createdByEntityId
                isFirm
                createdAt
                updatedAt
              }
              searchName
              taxNumber
              taskSendSMS
              companyNumber
              createdBy
              createdAt
              updatedAt
              status
              partnerId
              managerId
              archivedAt
              taxPaymentReferences {
                itr {
                  referenceNumber
                  updatedAt
                }
                other {
                  referenceNumber
                  updatedAt
                }
              }
            }
            nextToken
          }
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        partnerId
        managerId
        archivedAt
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      otherRecipients {
        email
        sendOnCompletion
      }
      payments {
        items {
          id
          paymentIntentId
          taskId
          entityId
          payInPaymentId
          providerTransactionId
          paymentProvider
          disbursementId
          fromId
          fromType
          toId
          toType
          buyerId
          sellerId
          entityIdTo
          amount
          netAmount
          payerFees
          totalAmount
          gstAmount
          installment
          installments
          feeAmount
          reference
          paymentType
          taxAmount
          currency
          feeIds
          ipAddress
          status
          payerUserStatus
          declinedReason
          isUnlimitedRecurring
          payoutFailureReason
          payoutFailureFields
          payoutDetails {
            bank {
              id
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              country
            }
            bpay {
              billerCode
              referenceNumber
            }
          }
          scheduledAt
          paidAt
          declinedAt
          createdAt
          receivedAt
          paidOutAt
          updatedAt
          voidedAt
          owner
          payoutFailedAt
        }
        nextToken
      }
      createdBy
      entityIdBy
      dueAt
      issuedAt
      notes
      reviewerFeedback {
        reviewedById
        feedback
        status
        createdAt
      }
      direction
      readBy
      gstInclusive
      isUnlimitedRecurring
      owner
      lineItems {
        serviceId
        description
        quantity
        unitAmount
        taxType
        lineAmount
        newService
      }
      xeroTenantId
      sendSMS
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      sendTemplate
      includeLetterhead
      templateJson
      templateHtml
      paymentAt
      lodgementAt
      period
      year
      createdAt
      updatedAt
      viewedAt
      readAt
      paidAt
      endAt
      quoteAcceptedAt
      completedAt
      payoutErrors
    }
  }
`;
export const getTaskGuest = /* GraphQL */ `
  query GetTaskGuest($id: ID, $entityId: ID) {
    getTaskGuest(id: $id, entityId: $entityId) {
      id
      entityId
      amount
      taxAmount
      annotations
      documentType
      subCategory
      fromId
      linkedTaskId
      futureLinkedTask {
        fromId
        fromType
        from {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toId
        toType
        to {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      firm {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      fromEntity {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      from {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      fromContact {
        id
        firstName
        lastName
        name
        createdAt
        updatedAt
      }
      fromType
      toEntity {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      toContact {
        id
        firstName
        lastName
        name
        createdAt
        updatedAt
      }
      toId
      to {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      toType
      isFinalSigner
      status
      signatureStatus
      paymentStatus
      quoteStatus
      invoiceStatus
      settlementStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      reference
      bpayReferenceNumber
      createdBy
      gstInclusive
      entityIdBy
      dueAt
      issuedAt
      notes
      direction
      paymentAt
      lodgementAt
      readAt
      paidAt
      quoteAcceptedAt
      completedAt
      owner
      metaHashData
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      termsFirmPayTaxAccepted
      createdAt
      updatedAt
      token
      period
      year
    }
  }
`;
export const getTaskPublic = /* GraphQL */ `
  query GetTaskPublic($token: ID!) {
    getTaskPublic(token: $token) {
      id
      entityId
      amount
      taxAmount
      annotations
      documentType
      subCategory
      fromId
      linkedTaskId
      futureLinkedTask {
        fromId
        fromType
        from {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toId
        toType
        to {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        numberOfPayments
        paymentFrequency
        reference
        bpayReferenceNumber
        amount
        gstInclusive
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        isUnlimitedRecurring
        direction
        invoiceStatus
        dueAt
        paymentAt
        lodgementAt
      }
      firm {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      fromEntity {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      from {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      fromContact {
        id
        firstName
        lastName
        name
        createdAt
        updatedAt
      }
      fromType
      toEntity {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      toContact {
        id
        firstName
        lastName
        name
        createdAt
        updatedAt
      }
      toId
      to {
        id
        name
        taxNumber
        createdAt
        updatedAt
      }
      toType
      isFinalSigner
      status
      signatureStatus
      paymentStatus
      quoteStatus
      invoiceStatus
      settlementStatus
      type
      category
      documents {
        identityId
        key
        level
        type
        name
      }
      supportDocuments {
        identityId
        key
        level
        type
        name
      }
      numberOfPayments
      paymentFrequency
      paymentTypes
      reference
      bpayReferenceNumber
      createdBy
      gstInclusive
      entityIdBy
      dueAt
      issuedAt
      notes
      direction
      paymentAt
      lodgementAt
      readAt
      paidAt
      quoteAcceptedAt
      completedAt
      owner
      metaHashData
      automaticGenerateInvoice
      automaticInvoicePaymentAt
      automaticInvoicePaymentTerms
      quoteRequiresSignature
      automaticallyGeneratedFromQuote
      termsFirmPayTaxAccepted
      createdAt
      updatedAt
      token
      period
      year
    }
  }
`;
export const getBindingTasksPublic = /* GraphQL */ `
  query GetBindingTasksPublic($token: ID!) {
    getBindingTasksPublic(token: $token) {
      tasks {
        id
        entityId
        amount
        taxAmount
        annotations
        documentType
        subCategory
        fromId
        linkedTaskId
        futureLinkedTask {
          fromId
          fromType
          from {
            id
            name
            taxNumber
            createdAt
            updatedAt
          }
          toId
          toType
          to {
            id
            name
            taxNumber
            createdAt
            updatedAt
          }
          numberOfPayments
          paymentFrequency
          reference
          bpayReferenceNumber
          amount
          gstInclusive
          lineItems {
            serviceId
            description
            quantity
            unitAmount
            taxType
            lineAmount
            newService
          }
          isUnlimitedRecurring
          direction
          invoiceStatus
          dueAt
          paymentAt
          lodgementAt
        }
        firm {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        fromEntity {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        from {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        fromContact {
          id
          firstName
          lastName
          name
          createdAt
          updatedAt
        }
        fromType
        toEntity {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toContact {
          id
          firstName
          lastName
          name
          createdAt
          updatedAt
        }
        toId
        to {
          id
          name
          taxNumber
          createdAt
          updatedAt
        }
        toType
        isFinalSigner
        status
        signatureStatus
        paymentStatus
        quoteStatus
        invoiceStatus
        settlementStatus
        type
        category
        documents {
          identityId
          key
          level
          type
          name
        }
        supportDocuments {
          identityId
          key
          level
          type
          name
        }
        numberOfPayments
        paymentFrequency
        paymentTypes
        reference
        bpayReferenceNumber
        createdBy
        gstInclusive
        entityIdBy
        dueAt
        issuedAt
        notes
        direction
        paymentAt
        lodgementAt
        readAt
        paidAt
        quoteAcceptedAt
        completedAt
        owner
        metaHashData
        automaticGenerateInvoice
        automaticInvoicePaymentAt
        automaticInvoicePaymentTerms
        quoteRequiresSignature
        automaticallyGeneratedFromQuote
        termsFirmPayTaxAccepted
        createdAt
        updatedAt
        token
        period
        year
      }
      documents {
        identityId
        key
        level
        type
        name
      }
    }
  }
`;
export const searchTasks = /* GraphQL */ `
  query SearchTasks(
    $firmId: ID
    $entityId: ID
    $contactId: ID
    $bindingId: ID
    $createdBy: ID
    $status: TaskSearchStatus
    $type: TaskSearchType!
    $searchName: String
    $dueAtStart: AWSDate
    $dueAtEnd: AWSDate
    $sortBy: SearchTasksSortBy
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
  ) {
    searchTasks(
      firmId: $firmId
      entityId: $entityId
      contactId: $contactId
      bindingId: $bindingId
      createdBy: $createdBy
      status: $status
      type: $type
      searchName: $searchName
      dueAtStart: $dueAtStart
      dueAtEnd: $dueAtEnd
      sortBy: $sortBy
      sortDirection: $sortDirection
      from: $from
      limit: $limit
    ) {
      items {
        entityId
        taskNumber
        invoiceStatus
        agreementUuid
        documentType
        subCategory
        id
        linkedTaskId
        managerId
        partnerId
        bindingId
        futureLinkedTask {
          fromId
          fromType
          toId
          toType
          numberOfPayments
          paymentFrequency
          reference
          bpayReferenceNumber
          amount
          gstInclusive
          lineItems {
            serviceId
            description
            quantity
            unitAmount
            taxType
            lineAmount
            newService
          }
          isUnlimitedRecurring
          direction
          invoiceStatus
          dueAt
          paymentAt
          lodgementAt
        }
        documentAnalysisId
        activity {
          items {
            id
            compositeId
            userId
            entityId
            type
            message
            metadata {
              name
              email
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        amount
        taxAmount
        annotations
        entityIdFrom
        fromId
        fromType
        toId
        toType
        firmId
        entityIdTo
        contactIdFrom
        contactIdTo
        contactId
        entityByIdContactId
        firmByIdContactId
        firmById
        searchName
        status
        quoteStatus
        signatureStatus
        paymentStatus
        type
        category
        documents {
          identityId
          key
          level
          type
          name
        }
        emailMessage
        supportDocuments {
          identityId
          key
          level
          type
          name
        }
        numberOfPayments
        paymentFrequency
        paymentTypes
        maximumInstallments
        reference
        bpayReferenceNumber
        settlementStatus
        signers {
          id
          entityId
          userId
          firmId
          email
          invitedEmail
          ocrEmail
          referredBy
          invitedEntityId
          firmEntityId
          providerContactId
          ownerCode
          clientGroupCode
          clientCode
          firstName
          lastName
          role
          jobTags
          paymentsEnabled
          termsInvoiceAccepted
          termsOcrAccepted
          termsFirmPayTaxAccepted
          termsFirmPayTaxDetails {
            document {
              identityId
              key
              level
              type
              name
            }
            acceptedAt
            email
            ip
            fullName
            firmId
          }
          entitySearchName
          entity {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          firm {
            id
            type
            taxNumber
            companyNumber
            billerCode
            name
            legalName
            businessNames
            searchName
            address {
              addressId
              contactName
              contactNumber
              fullAddress
              address1
              address2
              city
              country
              countryCode
              state
              stateCode
              postalCode
              invalid
            }
            logo {
              alt
              identityId
              key
              level
              type
            }
            brandColour
            website
            entityUsers {
              items {
                id
                entityId
                userId
                firmId
                email
                invitedEmail
                ocrEmail
                referredBy
                invitedEntityId
                firmEntityId
                providerContactId
                ownerCode
                clientGroupCode
                clientCode
                firstName
                lastName
                role
                jobTags
                paymentsEnabled
                termsInvoiceAccepted
                termsOcrAccepted
                termsFirmPayTaxAccepted
                termsFirmPayTaxDetails {
                  acceptedAt
                  email
                  ip
                  fullName
                  firmId
                }
                entitySearchName
                entity {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                firm {
                  id
                  type
                  taxNumber
                  companyNumber
                  billerCode
                  name
                  legalName
                  businessNames
                  searchName
                  brandColour
                  website
                  gstRegistered
                  gstReportingPeriod
                  providerEntityId
                  providerCompanyId
                  providerBillUserCompanyId
                  providerBankAccountId
                  providerDigitalWalletId
                  providerBpayCrn
                  paymentMethodId
                  paymentUserId
                  disbursementMethodId
                  ubosCreated
                  numUbosCreated
                  subCategory
                  clientsStatus
                  ocrEmail
                  termsInvoiceAccepted
                  termsOcrAccepted
                  owner
                  referredBy
                  connectedAccount
                  accountStatus
                  customerId
                  xeroSyncStatus
                  xeroLastContactSyncAt
                  xeroContactSyncStatus
                  xeroInvoiceSyncStatus
                  xeroLastInvoiceSyncAt
                  xeroTenantId
                  absorbFees
                  subscriptionTier
                  invitationStatus
                  clientsOnboardingStatus
                  createdBy
                  createdByEntityId
                  isFirm
                  createdAt
                  updatedAt
                }
                searchName
                taxNumber
                taskSendSMS
                companyNumber
                createdBy
                createdAt
                updatedAt
                status
                partnerId
                managerId
                archivedAt
              }
              nextToken
            }
            gstRegistered
            gstReportingPeriod
            providerEntityId
            providerCompanyId
            providerBillUserCompanyId
            providerBankAccountId
            providerDigitalWalletId
            providerBpayCrn
            contact {
              firstName
              lastName
              email
              phone
              role
            }
            paymentMethods {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            paymentMethodId
            paymentUserId
            disbursementMethodId
            receivingAccounts {
              items {
                id
                paymentMethodType
                type
                fullName
                number
                expMonth
                expYear
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                status
                accountDirection
                expiresAt
                createdAt
                updatedAt
                consentId
                consentStatus
                card
                googlepay
                applepay
              }
              nextToken
            }
            ubosCreated
            numUbosCreated
            subCategory
            clientsStatus
            ocrEmail
            termsInvoiceAccepted
            termsOcrAccepted
            owner
            referredBy
            connectedAccount
            accountStatus
            customerId
            xeroSyncStatus
            xeroLastContactSyncAt
            xeroContactSyncStatus
            xeroInvoiceSyncStatus
            xeroLastInvoiceSyncAt
            xeroTenantId
            absorbFees
            subscriptionTier
            invitationStatus
            clientsOnboardingStatus
            createdBy
            createdByEntityId
            isFirm
            createdAt
            updatedAt
          }
          searchName
          taxNumber
          taskSendSMS
          companyNumber
          createdBy
          createdAt
          updatedAt
          status
          partnerId
          managerId
          archivedAt
          taxPaymentReferences {
            itr {
              referenceNumber
              updatedAt
            }
            other {
              referenceNumber
              updatedAt
            }
          }
        }
        otherRecipients {
          email
          sendOnCompletion
        }
        payments {
          items {
            id
            paymentIntentId
            taskId
            entityId
            payInPaymentId
            providerTransactionId
            paymentProvider
            disbursementId
            fromId
            fromType
            toId
            toType
            buyerId
            sellerId
            entityIdTo
            amount
            netAmount
            payerFees
            totalAmount
            gstAmount
            installment
            installments
            feeAmount
            reference
            paymentType
            taxAmount
            currency
            feeIds
            ipAddress
            status
            payerUserStatus
            declinedReason
            isUnlimitedRecurring
            payoutFailureReason
            payoutFailureFields
            payoutDetails {
              bank {
                id
                accountName
                bankName
                accountNumber
                routingNumber
                holderType
                accountType
                country
              }
              bpay {
                billerCode
                referenceNumber
              }
            }
            scheduledAt
            paidAt
            declinedAt
            createdAt
            receivedAt
            paidOutAt
            updatedAt
            voidedAt
            owner
            payoutFailedAt
          }
          nextToken
        }
        createdBy
        entityIdBy
        dueAt
        issuedAt
        notes
        reviewerFeedback {
          reviewedById
          feedback
          status
          createdAt
        }
        direction
        readBy
        gstInclusive
        isUnlimitedRecurring
        owner
        lineItems {
          serviceId
          description
          quantity
          unitAmount
          taxType
          lineAmount
          newService
        }
        xeroTenantId
        sendSMS
        automaticGenerateInvoice
        automaticInvoicePaymentAt
        automaticInvoicePaymentTerms
        quoteRequiresSignature
        automaticallyGeneratedFromQuote
        sendTemplate
        includeLetterhead
        templateJson
        templateHtml
        paymentAt
        lodgementAt
        period
        year
        createdAt
        updatedAt
        viewedAt
        readAt
        paidAt
        endAt
        quoteAcceptedAt
        completedAt
        payoutErrors
      }
      total
    }
  }
`;
export const searchTaskCounts = /* GraphQL */ `
  query SearchTaskCounts(
    $firmId: ID
    $entityId: ID
    $contactId: ID
    $createdBy: String
    $status: TaskSearchStatus
    $searchName: String
    $dueAtStart: AWSDate
    $dueAtEnd: AWSDate
  ) {
    searchTaskCounts(
      firmId: $firmId
      entityId: $entityId
      contactId: $contactId
      createdBy: $createdBy
      status: $status
      searchName: $searchName
      dueAtStart: $dueAtStart
      dueAtEnd: $dueAtEnd
    ) {
      ALL
      TAX_BILLS
      INVOICES
      QUOTES
      BILLS
      ESIGNATURE
    }
  }
`;
export const tasksOverdueCounts = /* GraphQL */ `
  query TasksOverdueCounts(
    $firmId: ID
    $entityId: ID
    $contactId: ID
    $status: TaskSearchStatus
    $types: [TaskSearchType!]!
    $sortDirection: ModelSortDirection
    $createdBy: ID
  ) {
    tasksOverdueCounts(
      firmId: $firmId
      entityId: $entityId
      contactId: $contactId
      status: $status
      types: $types
      sortDirection: $sortDirection
      createdBy: $createdBy
    ) {
      TAX_BILLS {
        tasks
        clients
        amount
      }
      INVOICES {
        tasks
        clients
        amount
      }
      BILLS {
        tasks
        clients
        amount
      }
      ESIGNATURE {
        tasks
        clients
        amount
      }
    }
  }
`;
export const transactionsByEntity = /* GraphQL */ `
  query TransactionsByEntity(
    $entityId: ID!
    $direction: String
    $status: String
    $startDate: AWSDate
    $endDate: AWSDate
    $amount: Int
    $netAmount: Int
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
  ) {
    transactionsByEntity(
      entityId: $entityId
      direction: $direction
      status: $status
      startDate: $startDate
      endDate: $endDate
      amount: $amount
      netAmount: $netAmount
      sortDirection: $sortDirection
      from: $from
      limit: $limit
    ) {
      items {
        id
        amount
        netAmount
        fee
        description
        status
        direction
        taskId
        entityId
        paymentId
        createdAt
        updatedAt
      }
      total
    }
  }
`;
export const getTaskNumber = /* GraphQL */ `
  query GetTaskNumber($entityId: ID!) {
    getTaskNumber(entityId: $entityId) {
      id
      invoice
      quote
    }
  }
`;
export const getTemplate = /* GraphQL */ `
  query GetTemplate($id: ID!) {
    getTemplate(id: $id) {
      id
      entityId
      title
      searchName
      templateJson
      templateHtml
      status
      canDelete
      type
      includeLetterhead
      createdAt
      updatedAt
    }
  }
`;
export const templatesByEntity = /* GraphQL */ `
  query TemplatesByEntity(
    $entityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    templatesByEntity(
      entityId: $entityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        title
        searchName
        templateJson
        templateHtml
        status
        canDelete
        type
        includeLetterhead
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTranslation = /* GraphQL */ `
  query GetTranslation($language: String, $namespace: String) {
    getTranslation(language: $language, namespace: $namespace) {
      language
      namespace
      data
    }
  }
`;
export const listTranslations = /* GraphQL */ `
  query ListTranslations {
    listTranslations {
      language
      items {
        language
        namespace
        data
      }
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      identityId
      referralCode
      referredBy
      email
      about
      firstName
      firmId
      lastName
      phone
      blocked
      blockedBy
      country
      profileImg {
        alt
        identityId
        key
        level
        type
      }
      interests
      locale
      onboardingStatus
      onboardingEntity
      selectedEntityId
      selectedSignatureKey
      signatures {
        items {
          id
          userId
          key
          createdAt
          updatedAt
        }
        nextToken
      }
      userType
      rating
      reportReasons
      notificationPreferences {
        email
        push
        sms
      }
      paymentUserId
      providerWalletId
      providerNppCrn
      ipAddress
      createdAt
      updatedAt
      owner
      loyaltyStatus
      nextLoyaltyStatus
      nextLoyaltyStatusPoint
      statusPoint
      pointsTotal
      pointsBalance
      invitedTo
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $id: ID
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        identityId
        referralCode
        referredBy
        email
        about
        firstName
        firmId
        lastName
        phone
        blocked
        blockedBy
        country
        profileImg {
          alt
          identityId
          key
          level
          type
        }
        interests
        locale
        onboardingStatus
        onboardingEntity
        selectedEntityId
        selectedSignatureKey
        signatures {
          items {
            id
            userId
            key
            createdAt
            updatedAt
          }
          nextToken
        }
        userType
        rating
        reportReasons
        notificationPreferences {
          email
          push
          sms
        }
        paymentUserId
        providerWalletId
        providerNppCrn
        ipAddress
        createdAt
        updatedAt
        owner
        loyaltyStatus
        nextLoyaltyStatus
        nextLoyaltyStatusPoint
        statusPoint
        pointsTotal
        pointsBalance
        invitedTo
      }
      nextToken
    }
  }
`;
export const getActivitiesByUser = /* GraphQL */ `
  query GetActivitiesByUser(
    $id: ID!
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    getActivitiesByUser(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        compositeId
        userId
        entityId
        type
        message
        metadata {
          name
          email
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReferralsByUser = /* GraphQL */ `
  query GetReferralsByUser(
    $id: ID!
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    getReferralsByUser(
      id: $id
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        referredId
        firstName
        lastName
        taskPaidCount
        referredByCode
        referredCompleted
        referredSignedStatus
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const xeroListContacts = /* GraphQL */ `
  query XeroListContacts($page: Int) {
    xeroListContacts(page: $page) {
      contactID
      contactNumber
      accountNumber
      contactStatus
      name
      firstName
      lastName
      emailAddress
      bankAccountDetails
      companyNumber
      taxNumber
      accountsReceivableTaxType
      accountsPayableTaxType
      addresses {
        addressType
        addressLine1
        addressLine2
        addressLine3
        addressLine4
        city
        region
        postalCode
        country
        attentionTo
      }
      phones {
        phoneType
        phoneNumber
        phoneAreaCode
        phoneCountryCode
      }
      isSupplier
      isCustomer
      defaultCurrency
      updatedDateUTC
      contactPersons {
        firstName
        lastName
        emailAddress
        includeInEmails
      }
      xeroNetworkKey
      mergedToContactID
      salesDefaultAccountCode
      purchasesDefaultAccountCode
      salesTrackingCategories
      purchasesTrackingCategories
      salesDefaultLineAmountType
      purchasesDefaultLineAmountType
      trackingCategoryName
      trackingCategoryOption
      paymentTerms
      website
      brandingTheme
      batchPayments
      discount
      validationErrors
      hasValidationErrors
      hasAttachments
      balances {
        accountsReceivable
        accountsPayable
      }
      statusAttributeString
    }
  }
`;
export const xeroListTransactions = /* GraphQL */ `
  query XeroListTransactions($statuses: [XeroInvoiceStatus], $page: Int) {
    xeroListTransactions(statuses: $statuses, page: $page) {
      invoiceID
      type
      status
      lineAmountTypes
      currencyCode
      date
      dueDate
      lineItems {
        lineItemID
        description
        quantity
        unitAmount
        itemCode
        accountCode
        accountID
        taxType
        taxAmount
        lineAmount
        taxNumber
        discountRate
        discountAmount
        repeatingInvoiceID
      }
      subTotal
      totalTax
      total
      invoiceNumber
      reference
      hasAttachments
      updatedDateUTC
      currencyRate
      remainingCredit
      amountDue
      amountPaid
      fullyPaidOnDate
      amountCredited
      brandingThemeID
      hasErrors
      contact {
        contactID
        contactNumber
        accountNumber
        contactStatus
        name
        firstName
        lastName
        emailAddress
        bankAccountDetails
        companyNumber
        taxNumber
        accountsReceivableTaxType
        accountsPayableTaxType
        addresses {
          addressType
          addressLine1
          addressLine2
          addressLine3
          addressLine4
          city
          region
          postalCode
          country
          attentionTo
        }
        phones {
          phoneType
          phoneNumber
          phoneAreaCode
          phoneCountryCode
        }
        isSupplier
        isCustomer
        defaultCurrency
        updatedDateUTC
        contactPersons {
          firstName
          lastName
          emailAddress
          includeInEmails
        }
        xeroNetworkKey
        mergedToContactID
        salesDefaultAccountCode
        purchasesDefaultAccountCode
        salesTrackingCategories
        purchasesTrackingCategories
        salesDefaultLineAmountType
        purchasesDefaultLineAmountType
        trackingCategoryName
        trackingCategoryOption
        paymentTerms
        website
        brandingTheme
        batchPayments
        discount
        validationErrors
        hasValidationErrors
        hasAttachments
        balances {
          accountsReceivable
          accountsPayable
        }
        statusAttributeString
      }
    }
  }
`;
export const xeroGetConnectionStatus = /* GraphQL */ `
  query XeroGetConnectionStatus {
    xeroGetConnectionStatus {
      isConnected
    }
  }
`;
export const xeroGetEntityConnectionStatus = /* GraphQL */ `
  query XeroGetEntityConnectionStatus(
    $input: XeroGetEntityConnectionStatusInput
  ) {
    xeroGetEntityConnectionStatus(input: $input) {
      isConnected
    }
  }
`;
export const xeroGetSyncedTenants = /* GraphQL */ `
  query XeroGetSyncedTenants {
    xeroGetSyncedTenants {
      id
      authEventId
      tenantId
      tenantType
      tenantName
      createdDateUtc
      updatedDateUtc
    }
  }
`;
export const xeroGetAccounts = /* GraphQL */ `
  query XeroGetAccounts($input: XeroGetAccountsInput) {
    xeroGetAccounts(input: $input) {
      code
      name
      accountID
      type
      bankAccountNumber
      status
      description
      bankAccountType
      currencyCode
      taxType
      enablePaymentsToAccount
      showInExpenseClaims
      _class
      systemAccount
      reportingCode
      reportingCodeName
      hasAttachments
      updatedDateUTC
      addToWatchlist
    }
  }
`;
export const getEmailProviderConnectionStatus = /* GraphQL */ `
  query GetEmailProviderConnectionStatus($entityId: ID!, $provider: String!) {
    getEmailProviderConnectionStatus(entityId: $entityId, provider: $provider) {
      isConnected
    }
  }
`;
export const getEntityPayId = /* GraphQL */ `
  query GetEntityPayId($entityId: ID!, $billPayments: [BillsPaymentInput]) {
    getEntityPayId(entityId: $entityId, billPayments: $billPayments) {
      transferAmount
      payId
      currency
      accountName
      accountNumber
      routingNumber
      currentBalance {
        availableAmount
        currency
        pendingAmount
        reservedAmount
        payableTaxAmount
        totalAmount
      }
    }
  }
`;
export const getCustomerSecret = /* GraphQL */ `
  query GetCustomerSecret($entityId: ID!) {
    getCustomerSecret(entityId: $entityId)
  }
`;
export const getBalanceHistory = /* GraphQL */ `
  query GetBalanceHistory(
    $entityId: ID!
    $limit: Int
    $pageNum: String
    $currency: String
  ) {
    getBalanceHistory(
      entityId: $entityId
      limit: $limit
      pageNum: $pageNum
      currency: $currency
    ) {
      hasMore
      items {
        source
        amount
        currency
        balance
        description
        fee
        postedAt
        sourceType
        transactionType
      }
      pageBefore
      pageAfter
    }
  }
`;
export const getAdmiinAccount = /* GraphQL */ `
  query GetAdmiinAccount($entityId: ID!, $currency: String) {
    getAdmiinAccount(entityId: $entityId, currency: $currency) {
      id
      currency
      accountName
      accountNumber
      routingNumber
      currentBalance {
        availableAmount
        currency
        pendingAmount
        reservedAmount
        payableTaxAmount
        totalAmount
      }
    }
  }
`;
export const transactionHistory = /* GraphQL */ `
  query TransactionHistory(
    $entityId: ID!
    $type: HistoryType
    $startDate: AWSDate
    $endDate: AWSDate
    $page: String
    $limit: Int
  ) {
    transactionHistory(
      entityId: $entityId
      type: $type
      startDate: $startDate
      endDate: $endDate
      page: $page
      limit: $limit
    ) {
      items {
        receiver
        payer
        reference
        description
        netAmount
        payerFees
        taxAmount
        totalAmount
        balance
        amount
        date
      }
    }
  }
`;
